import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // Shared filters for both plan and historical views
  sharedFilters: {
    selectedProgram: [],
    selectedSurgeon: [],
    selectedRec: [],
  },
  // Last updated timestamp for cache invalidation
  lastUpdated: null,
};

export const filterPersistenceSlice = createSlice({
  name: "filterPersistence",
  initialState,
  reducers: {
    setSharedFilters(state, action) {
      state.sharedFilters = { ...state.sharedFilters, ...action.payload };
      state.lastUpdated = Date.now();
    },
    setProgramFilter(state, action) {
      state.sharedFilters.selectedProgram = action.payload;
      state.lastUpdated = Date.now();
    },
    setSurgeonFilter(state, action) {
      state.sharedFilters.selectedSurgeon = action.payload;
      state.lastUpdated = Date.now();
    },
    setRecFilter(state, action) {
      state.sharedFilters.selectedRec = action.payload;
      state.lastUpdated = Date.now();
    },
    // Legacy actions for backward compatibility (they now update shared filters)
    setPlanProgramFilter(state, action) {
      state.sharedFilters.selectedProgram = action.payload;
      state.lastUpdated = Date.now();
    },
    setPlanSurgeonFilter(state, action) {
      state.sharedFilters.selectedSurgeon = action.payload;
      state.lastUpdated = Date.now();
    },
    setPlanRecFilter(state, action) {
      state.sharedFilters.selectedRec = action.payload;
      state.lastUpdated = Date.now();
    },
    setHistoricalProgramFilter(state, action) {
      state.sharedFilters.selectedProgram = action.payload;
      state.lastUpdated = Date.now();
    },
    setHistoricalSurgeonFilter(state, action) {
      state.sharedFilters.selectedSurgeon = action.payload;
      state.lastUpdated = Date.now();
    },
    setHistoricalRecFilter(state, action) {
      state.sharedFilters.selectedRec = action.payload;
      state.lastUpdated = Date.now();
    },
    clearSharedFilters(state) {
      state.sharedFilters = {
        selectedProgram: [],
        selectedSurgeon: [],
        selectedRec: [],
      };
      state.lastUpdated = Date.now();
    },
    // Legacy actions for backward compatibility (they now clear shared filters)
    clearPlanFilters(state) {
      state.sharedFilters = {
        selectedProgram: [],
        selectedSurgeon: [],
        selectedRec: [],
      };
      state.lastUpdated = Date.now();
    },
    clearHistoricalFilters(state) {
      state.sharedFilters = {
        selectedProgram: [],
        selectedSurgeon: [],
        selectedRec: [],
      };
      state.lastUpdated = Date.now();
    },
    clearAllFilters(state) {
      state.sharedFilters = {
        selectedProgram: [],
        selectedSurgeon: [],
        selectedRec: [],
      };
      state.lastUpdated = Date.now();
    },
    // Action to restore filters from localStorage
    restoreFiltersFromStorage(state, action) {
      const { sharedFilters, planFilters, historicalFilters, lastUpdated } = action.payload;

      // If new shared filters format exists, use it
      if (sharedFilters) {
        state.sharedFilters = sharedFilters;
      } else {
        // Legacy support: if old format exists, migrate to shared filters
        // Use planFilters as the source of truth for migration
        if (planFilters) {
          state.sharedFilters = planFilters;
        } else if (historicalFilters) {
          state.sharedFilters = historicalFilters;
        }
      }

      if (lastUpdated) {
        state.lastUpdated = lastUpdated;
      }
    },
  },
});

export const {
  // New shared actions
  setSharedFilters,
  setProgramFilter,
  setSurgeonFilter,
  setRecFilter,
  clearSharedFilters,
  // Legacy actions (for backward compatibility)
  setPlanFilters,
  setHistoricalFilters,
  setPlanProgramFilter,
  setPlanSurgeonFilter,
  setPlanRecFilter,
  setHistoricalProgramFilter,
  setHistoricalSurgeonFilter,
  setHistoricalRecFilter,
  clearPlanFilters,
  clearHistoricalFilters,
  clearAllFilters,
  restoreFiltersFromStorage,
} = filterPersistenceSlice.actions;

export const { reducer: filterPersistenceReducer } = filterPersistenceSlice;
